import * as React from 'react';
import i18n from 'i18next';
import './styles/Loading.scss';

const Loading = () => {
	return (
		<div className={'loading'}>
			{i18n.t('LOADING_PLEASE_WAIT')}
		</div>
	)
}

export default Loading;